import type { Vendor } from '@cruz-com/lookup'
import { baseURL, formatFetchError, getHeader } from '../util'

export async function toggleShowDefaultProfile(id: string): Promise<Partial<Vendor.Location>> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/carsforsale-import/location/toggle-show-default-profile?id=${id}`, {
      method: 'PATCH',
      headers,
      cache: 'no-store',
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
